import Model from '../models'

export default Model.Collection.actions
